import React from 'react';
import ProgressiveImage from '../ProgressiveImage/ProgressiveImage';
import './ArticleImage.less';

const ImageTag = ({mediaFile, alignMedia, caption}) => {
    if (mediaFile && mediaFile.url) {
        const imageClass = `ArticleImage ArticleImage--${(
            alignMedia || 'full-width'
        ).toLowerCase()}`;

        return (
            <figure className={imageClass}>
                <ProgressiveImage
                    src={mediaFile.url}
                    alt={mediaFile.description}
                    withHeight={false}
                />
                {caption && (
                    <figcaption className="ArticleImage__caption small">
                        {caption}
                    </figcaption>
                )}
            </figure>
        );
    }
    return null;
};

const ArticleImage = ({mediaFile, alignMedia, caption, link}) => {
    if (ImageTag && link) {
        return (
            <a href={link} className="ArticleImageLink">
                <ImageTag
                    mediaFile={mediaFile}
                    alignMedia={alignMedia}
                    caption={caption}
                />
            </a>
        );
    }
    return (
        <ImageTag
            mediaFile={mediaFile}
            alignMedia={alignMedia}
            caption={caption}
        />
    );
};

export default ArticleImage;
